/**
 * Created by Victor Rojo on 9/10/18.
 */
import { OnDestroy }        from '@angular/core';

import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";
import {WidgetStatus} from "../../widget/Widget";
import {Widget} from "../../widget/Widget";


export abstract class WidgetStatusChangeAware implements OnDestroy {

  protected _widget: Widget;
  widgetStatusChangeSubscription: any;

  constructor(private iPlaceDataChangeService: IPlaceDataChangeService) {

    this.widgetStatusChangeSubscription = this.iPlaceDataChangeService.widgetStatusChange$.subscribe( (widgetStatus:WidgetStatus) => {
      if ( widgetStatus.widgetId == this._widget.widgetId ) {
        if ( widgetStatus.statusUpdate >= this._widget.statusUpdate ) {
          this._widget.statusLevelId = widgetStatus.statusLevelId;
          this._widget.statusUpdate = widgetStatus.statusUpdate;
        }
        this._widget.widgetStatusList = widgetStatus.lines;
      }
    });
  }

  public ngOnDestroy(): void {
    if ( this.widgetStatusChangeSubscription ){
      this.widgetStatusChangeSubscription.unsubscribe();
    }
  }
}
